import React, { useMemo } from "react";
import { useTranslation } from "react-i18next"
import { Controller } from "react-hook-form"
import InputWithAddOptions from "@components/input/InputWithAddOptions"
import { useReduxSelector } from "@hooks/useReduxSelector"
import { checkEnterpriseId } from "@helpers/_functions"
import useCLothes from "@pages/shared/employeFormNew/PersonnalInformations/hooksClothes"

export const useSectionClothesColumns = () => {
  const { TYPES } = useCLothes()
  const { t } = useTranslation("pages.employés.healthPrecision")

  return useMemo(
    () => TYPES.map((_type) => ({ id: _type._id, label: t(_type.label) })),
    [TYPES, t]
  )
}

export const SectionClothesTableBulkHeader = ({ hiddenColumns = {} }) => {
  const { t: mainTranslator } = useTranslation("pages.employés.healthPrecision")
  const { TYPES } = useCLothes()

  return (
    <>
      {TYPES.map((_type) => (
        <th
          key={_type._id}
          className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-max-w-[12.5rem] arh-bg-greyColor arh-px-5 arh-py-[10px] arh-align-bottom arh-text-xs arh-font-semibold arh-text-darkColor ${hiddenColumns[_type._id] ? "arh-hidden" : ""}`}
        >
          {mainTranslator(_type.label)}
        </th>
      ))}
    </>
  )
}

export const SectionClothesTableBulkCells = ({
  control,
  employeeIndex,
  employee,
  setSuperZIndex,
  readOnly = false,
  mustWait,
  hiddenColumns = {}
}) => {
  const { t: mainTranslator } = useTranslation("pages.employés.healthPrecision")
  const { TYPES, deleteById, upsert } = useCLothes()
  const clothes = useReduxSelector(({ enterpriseEmployeData: { clothes } }) => clothes?.list)

  const readOnlyAccess = mustWait || readOnly

  return (
    <>
      {TYPES.map((_type) => (
        <td
          key={_type._id}
          className={`arh-w-[12.5rem] arh-min-w-[12.5rem] arh-max-w-[12.5rem] arh-p-4 arh-px-5 arh-font-poppins arh-text-xs arh-text-darkGreyColor ${hiddenColumns[_type._id] ? "arh-hidden" : ""}`}
        >
          <div className="arh-flex arh-flex-col">
            <Controller
              control={control}
              name={`employees.${employeeIndex}.${_type._id}`}
              defaultValue={employee?.[_type._id] || []}
              render={({ field: { onChange, value, name }, fieldState: { invalid } }) => (
              <InputWithAddOptions
                name={name}
                defaultText={mainTranslator(_type.label)}
                optionsList={clothes?.filter((_clothe) => _clothe.type === _type._id)}
                secondDefaultText={mainTranslator("Ajouter")}
                value={value}
                optionListLabel="name"
                onChange={onChange}
                addItem={(body) =>
                  upsert(
                    {
                      ...body,
                      type: _type._id,
                      Enterprise: checkEnterpriseId(),
                    },
                    _type._id,
                  )
                }
                editItem={(body) =>
                  upsert(
                    {
                      ...body,
                      type: _type._id,
                      Enterprise: checkEnterpriseId(),
                    },
                    _type._id,
                  )
                }
                deleteItem={(body) => deleteById(body, _type._id)}
                classInput="!arh-py-[5px] !arh-px-2.5 !arh-pr-8 arh-truncate arh-whitespace-nowrap arh-overflow-hidden"
                validateDropdown={invalid}
                multiple
                setSuperZIndex={setSuperZIndex}
                showAction
                disabled={readOnlyAccess}
                classBtn="arh-absolute arh-right-1 arh-top-1/2 -arh-translate-y-1/2 !arh-py-[0.0625rem] !arh-px-2.5"
              />
            )}
            />
          </div>
        </td>
      ))}
    </>
  )
}

export const getClothesColumnCount = () => 5